import Button from '@/common/components/base/button/Button';
import LoadingButton from '@/common/components/base/button/loadingButton';
import MobileInput from '@/common/components/base/input/mobileInput/MobileInput';
import TextInput from '@/common/components/base/input/textInput/TextInput';
import { PHONE_NUMBER_RULE } from '@/common/utils/rules/phoneNumber.rules';
import { POSTAL_CODE_RULE } from '@/common/utils/rules/postalCode.rules';
import { requiredText } from '@/common/utils/rules/publicRules';
import ImagesFabMainModal from '@/modules/adjusterReportModules/adjusterReport/components/imagesFab/ImagesFabMainModal';
import { ADJUSTER_REPORT_CULPRIT_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/culprit/culpritLinks';
import { IOwnerInformationForm } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/getOwnerInformation/getOwnerInformationQuery.type';
import { usePatchContactOwnerFormQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/patchContactOwnerForm/patchContactOwnerFormQueryOptions';
import { FormProvider, useFormContext, useWatch } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';

const ContactOwnerForm = () => {
  const methods = useFormContext<IOwnerInformationForm>();
  const { mutate, isPending } = usePatchContactOwnerFormQueryOptions();
  const { id } = useParams();
  const navigate = useNavigate();
  const phoneNumber = useWatch({
    control: methods.control,
    name: 'contact_information.phone',
  });
  const submitHandler = (formData: IOwnerInformationForm) => {
    mutate(
      {
        data: {
          ...formData.contact_information,

          city_code:
            formData.contact_information?.city_code === ''
              ? null
              : formData.contact_information?.city_code,
          phone:
            formData.contact_information?.phone === ''
              ? null
              : formData.contact_information?.phone,
        },
        id: id!,
      },
      {
        onSuccess: () => {
          navigate(-1);
        },
      },
    );
  };
  const previousStep = () => {
    navigate(
      ADJUSTER_REPORT_CULPRIT_LINKS.CULPRIT_INFORMATION({
        id: +id!,
      }).DRIVER_OWNER_INFORMATION.owner,
      { replace: true },
    );
  };
  return (
    <>
      <FormProvider {...methods}>
        <Flex direction="column" gap={8}>
          <MobileInput
            name="contact_information.phone_number"
            label="تلفن همراه"
            rules={{
              required: requiredText,
            }}
          />
          <Box display="flex" flexDirection="row" gap="10px">
            <Box flexBasis={'80%'}>
              <TextInput
                name="contact_information.phone"
                label="تلفن ثابت"
                placeholder="XX-XX-XX-XX"
                key={'phone'}
                rules={{ ...PHONE_NUMBER_RULE, required: requiredText }}
                max={8}
                noCharInput={true}
                direction="ltr"
              />
            </Box>
            <Box flexBasis={'30%'}>
              <TextInput
                name="contact_information.city_code"
                key={'city_code'}
                placeholder="کد شهر"
                rules={{
                  minLength: { message: 'پیش شماره شهر 3 رقمی است', value: 3 },
                  required: {
                    message: requiredText,
                    value: phoneNumber ? true : false,
                  },
                }}
                max={3}
                direction="ltr"
                noCharInput={true}
              />
            </Box>
          </Box>
          <TextInput
            name="contact_information.postal_code"
            label="کد پستی"
            optionalLabel
            key={'economic_code'}
            max={10}
            noCharInput
            rules={POSTAL_CODE_RULE}
          />
          <TextInput
            name="contact_information.address"
            label="ادرس"
            optionalLabel
            key={'address'}
          />
          <Flex w="100%" gap={16} mb="1rem">
            <Button fullWidth variant="outlined" onClick={previousStep}>
              مرحله قبل
            </Button>{' '}
            <LoadingButton
              onClick={methods.handleSubmit(submitHandler)}
              type="submit"
              width="100%"
              loading={isPending}
              disabled={!methods?.formState?.isValid}
            >
              تائید و ادامه
            </LoadingButton>
          </Flex>
        </Flex>
      </FormProvider>
      <ImagesFabMainModal state={'propertyCulprit'} />
    </>
  );
};
export default ContactOwnerForm;
